module.exports = __webpack_public_path__ + "img/icon-package-5g-light.8ff7f84.svg";